import { useRef, useState } from "react";
import api, { formatApiError } from "@/lib/api";
import { toast } from "sonner";
import { Upload, Loader2 } from "lucide-react";

export const ImageUpload = ({ value, onChange, label, testid, compact = false }) => {
  const inputRef = useRef(null);
  const [loading, setLoading] = useState(false);

  const handleFile = async (e) => {
    const file = e.target.files?.[0];
    if (!file) return;
    setLoading(true);
    try {
      const fd = new FormData();
      fd.append("file", file);
      const { data } = await api.post("/upload", fd, { headers: { "Content-Type": "multipart/form-data" } });
      onChange(data.url);
      toast.success("Bild hochgeladen.");
    } catch (err) {
      toast.error(formatApiError(err.response?.data?.detail) || "Upload fehlgeschlagen.");
    } finally {
      setLoading(false);
      if (inputRef.current) inputRef.current.value = "";
    }
  };

  return (
    <div className="space-y-2">
      {label && <label className="text-xs text-zinc-500 block">{label}</label>}
      <div className="flex items-center gap-3">
        {value ? (
          <img src={value} alt="" className={`rounded-xl object-cover border border-zinc-800 ${compact ? "w-16 h-16" : "w-24 h-16"}`} />
        ) : (
          <div className={`rounded-xl bg-zinc-950 border border-dashed border-zinc-700 flex items-center justify-center text-zinc-600 ${compact ? "w-16 h-16" : "w-24 h-16"}`}>
            <Upload className="w-5 h-5" />
          </div>
        )}
        <button type="button" onClick={() => inputRef.current?.click()} disabled={loading}
          data-testid={testid}
          className="btn-secondary !py-2 !px-4 text-sm">
          {loading ? <Loader2 className="w-4 h-4 animate-spin" /> : <><Upload className="w-4 h-4" /> Bild hochladen</>}
        </button>
        <input ref={inputRef} type="file" accept="image/*" className="hidden" onChange={handleFile} />
      </div>
      <input className="input-dark text-xs" placeholder="oder Bild-URL einfügen" value={value || ""} onChange={(e) => onChange(e.target.value)} />
    </div>
  );
};
